// src/utils/format.js

export function tempoDesde(data) {
  if (!data) return '';
  try {
    const inicio = data.toDate();
    const agora = new Date();
    const diffMs = agora - inicio;
    const dias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const horas = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
    const minutos = Math.floor((diffMs / (1000 * 60)) % 60);
    if (dias > 0) return `${dias}d ${horas}h`;
    if (horas > 0) return `${horas}h ${minutos}min`;
    return `${minutos}min`;
  } catch {
    return '';
  }
}

export function formatarData(data) {
  if (!data) return '';
  try {
    return data.toDate().toLocaleString('pt-BR');
  } catch {
    return '';
  }
}
